import { render } from "./AppWrapperView.vue?vue&type=template&id=8d99b734"
import script from "./AppWrapperView.vue?vue&type=script&lang=js"
export * from "./AppWrapperView.vue?vue&type=script&lang=js"

import "./AppWrapperView.vue?vue&type=style&index=0&id=8d99b734&lang=css"

import exportComponent from "/codebuild/output/src413274616/src/hybrid_inventory_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__